__webpack_require__.p = "/stats/";